// ===================================
// KAIXO - Sparkline (mini gráfica SVG sin dependencias)
// ===================================

import React from 'react';

/**
 * @param data  - array de números
 * @param width / height - dimensiones del SVG
 * @param color - color de la línea
 * @param fill  - si true, rellena debajo
 */
function Sparkline({ data = [], width = 120, height = 32, color = '#00b4d8', fill = true }) {
    if (!data.length) {
        return <svg width={width} height={height}><line x1={0} y1={height / 2} x2={width} y2={height / 2} stroke="#ccc" strokeDasharray="3 3" /></svg>;
    }
    const max = Math.max(...data, 1);
    const min = 0;
    const range = max - min || 1;
    const stepX = width / Math.max(data.length - 1, 1);

    const points = data.map((v, i) => {
        const x = i * stepX;
        const y = height - ((v - min) / range) * height;
        return [x, y];
    });

    const pathLine = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
    const pathFill = `${pathLine} L${width},${height} L0,${height} Z`;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            {fill && <path d={pathFill} fill={color} fillOpacity={0.15} />}
            <path d={pathLine} fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
            {points.map(([x, y], i) => (
                <circle key={i} cx={x} cy={y} r={i === points.length - 1 ? 2.5 : 0} fill={color} />
            ))}
        </svg>
    );
}

export default Sparkline;
